var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.42621 25.6817L3.82101 28.2363C4.11085 28.7742 4.52743 29.1968 5.01654 29.5042C6.41752 27.6185 7.39253 26.1714 7.94205 25.1631C8.4996 24.1398 9.18489 22.5391 9.99793 20.3611C7.80677 20.0552 6.14634 19.9023 5.01667 19.9023C3.93233 19.9023 2.27191 20.0552 0.0351562 20.3611C0.0351562 20.9565 0.180072 21.552 0.469905 22.0899L2.42621 25.6817Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.68 29.5042C27.1693 29.1968 27.5858 28.7742 27.8755 28.2364L28.4552 27.18L31.2268 22.0899C31.5112 21.5636 31.6611 20.9677 31.6614 20.3611C29.4117 20.0552 27.7544 19.9023 26.6892 19.9023C25.5444 19.9023 23.887 20.0552 21.7168 20.3611C22.5202 22.551 23.1965 24.1517 23.7456 25.1631C24.2995 26.1835 25.2776 27.6304 26.68 29.5042Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8505 9.60406C17.4714 7.5283 18.5885 5.92755 19.2016 4.8021C19.6954 3.89581 20.2389 2.44873 20.8319 0.461004C20.3428 0.153668 19.7813 0 19.2016 0H12.4994C11.9198 0 11.3584 0.172926 10.8691 0.461004C11.6235 2.74074 12.2637 4.36323 12.7895 5.32834C13.3706 6.39498 14.391 7.82018 15.8505 9.60406Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7006 20.3613H9.99884L5.01758 29.5044C5.50656 29.8117 6.06807 29.9654 6.64773 29.9654H25.0517C25.6314 29.9654 26.193 29.7925 26.682 29.5043L21.7007 20.3613H21.7006Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8488 9.60386L10.8675 0.460938C10.3783 0.768274 9.96173 1.19076 9.6719 1.72867L0.469905 18.6318C0.1854 19.158 0.0355321 19.7539 0.0351562 20.3605H9.99793L15.8489 9.60386H15.8488Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6275 10.1803L22.0264 1.72867C21.7367 1.19076 21.32 0.768274 20.8309 0.460938L15.8496 9.60399L21.7004 20.3606H31.6451C31.6451 19.7651 31.5002 19.1698 31.2104 18.6319L26.6275 10.1803Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6271,
    height: 30,
    fill: "white",
    transform: "translate(0.0351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleDrive);
export default __webpack_public_path__ + "static/media/logos_google-drive.b083de9d24f8dd95c89f17a98f55228a.svg";
export { ForwardRef as ReactComponent };